import * as React from "react"

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  const { height = 24, width = 24, color = "#72808F" } = props
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16" fill="none" {...props}>
    <path d="M3.4533 10.1975C2.61491 10.6889 0.416727 11.6923 1.75557 12.9479C2.40958 13.5612 3.13798 13.9999 4.05376 13.9999H9.27938C10.1952 13.9999 10.9236 13.5612 11.5776 12.9479C12.9165 11.6923 10.7183 10.6889 9.87985 10.1975C7.91385 9.04517 5.41929 9.04517 3.4533 10.1975Z" stroke={color} strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9.33333 4.66667C9.33333 6.13943 8.1394 7.33333 6.66667 7.33333C5.19391 7.33333 4 6.13943 4 4.66667C4 3.19391 5.19391 2 6.66667 2C8.1394 2 9.33333 3.19391 9.33333 4.66667Z" stroke={color}/>
    <path d="M12.9999 2.66675V6.00008M14.6666 4.33341H11.3333" stroke={color} strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

export default SvgComponent
